// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610221326/js/" + chunkId + "." + {"44":"524b6b06","225":"e4338af3","481":"44fdd616","486":"7ebca00f","770":"40fc0b30"}[chunkId] + ".0.19403355397505762.chunk.js";
};